import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import AdminNavbar from "../../modules/admin/AdminNavbar";
import Table from "../../modules/layout/Table";
import {
  isQuestionAddModalOpenState,
  isQuestionModifyModalOpenState,
} from "../../../recoil/admin/examRoom";
import AdminQuestionAddModal from "./AdminQuestionAddModal";
import AdminQuestionModifyModal from "./AdminQuestionModifyModal";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import useQuestionActions from "../../../api/hooks/admin/question";
import { selectedComboSnState } from "../../../recoil/admin/question";
import { EXAMTYPE } from "../../../submodules/enum/exam";
import {
  examTypeOptionIfCombo1,
  examTypeOptionIfCombo2,
  examTypeOptionIfCombo3,
  examTypeOptionIfCombo4,
  examTypeOptionIfCombo5,
} from "../../../static";
import Select from "../../atoms/input/Select";
import { speakLanguageOption } from "../../../static";
import { comboOption } from "../../../static";

const AdminQuestion = () => {
  const setIsQuestionAddModalOpen = useSetRecoilState(
    isQuestionAddModalOpenState
  );
  const setIsQuestionModifyModalOpen = useSetRecoilState(
    isQuestionModifyModalOpenState
  );

  const setComboSn = useSetRecoilState(selectedComboSnState);

  const { fetchComboList } = useQuestionActions();

  const selectdefaultValue = "";
  const [selectCatagory, setSelectCatagory] = useState("");
  const [selectCombo, setSelectCombo] = useState("");
  const [selectRoom_type, setSelectRoom_type] = useState("");
  const [selectKeyword, setSelectKeyword] = useState("");
  const { data: comboList } = useQuery({
    queryKey: [
      "fetchCombos",
      selectCatagory,
      selectCombo,
      selectRoom_type,
      selectKeyword,
    ],
    queryFn: () =>
      fetchComboList({
        catagory: selectCatagory,
        combo: selectCombo,
        room_type: selectRoom_type,
        keyword: selectKeyword,
      }),
    onSuccess: () => {
      // console.log("selectRoom_type", selectRoom_type);
      // console.log("selectCombo", selectCombo);
      // console.log("selectCatagory", selectCatagory);
      // console.log("selectKeyword", selectKeyword);
      // console.log("-----");
    },
  });

  const [modifyingSn] = useState();

  const queryClient = useQueryClient();
  const { deleteCombo } = useQuestionActions();

  const mutation = useMutation(deleteCombo, {
    onSuccess: (context) => {
      alert("삭제되었습니다.");
    },
    onError: (context) => {
      alert(context?.response?.data?.text);
    },
  });

  return (
    <>
      <div>
        <link rel="stylesheet" type="text/css" href="/css/admin.css" />
        <link rel="stylesheet" type="text/css" href="/css/koica.css" />
        <AdminNavbar />

        <div className="admin_content">
          <div className="content-title">
            <p className="question">문항</p>
          </div>
          <div className="content-cont">
            <div className="container">
              <div className="tab-title">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="home-tab"
                      type="button"
                    >
                      콤보목록
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="flex filtering" style={{ marginTop: 0 }}>
                    <div>
                      <button
                        type="button"
                        className="btn-custom b-btn plus"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsQuestionAddModalOpen(true);
                          setComboSn(0);
                        }}
                      >
                        콤보 추가
                      </button>
                    </div>
                    {/* 룸타입, 대분류, 중분류 */}
                    <div>
                      <div className="dropdown content1-dropdown">
                        <Select
                          placeholder="선택"
                          options={comboOption}
                          required={true}
                          onChange={(e) => {
                            setSelectCombo(e.target.value);
                          }}
                          value={selectCombo}
                        />
                      </div>
                      <div className="dropdown content1-dropdown">
                        <Select
                          placeholder="선택"
                          required={true}
                          options={
                            selectCombo === comboOption[0].value
                              ? examTypeOptionIfCombo1
                              : selectCombo === comboOption[1].value
                              ? examTypeOptionIfCombo2
                              : selectCombo === comboOption[2].value
                              ? examTypeOptionIfCombo3
                              : selectCombo === comboOption[3].value
                              ? examTypeOptionIfCombo4
                              : selectCombo === comboOption[4].value
                              ? examTypeOptionIfCombo5
                              : []
                          }
                          onChange={(e) => {
                            setSelectCatagory(e.target.value);
                          }}
                          value={selectCatagory}
                        />
                      </div>
                      <div className="dropdown content1-dropdown">
                        <Select
                          options={speakLanguageOption}
                          onChange={(e) => {
                            setSelectRoom_type(e.target.value);
                          }}
                          value={selectRoom_type}
                        ></Select>
                      </div>
                      <div className="dropdown content1-dropdown">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="문항"
                          onChange={(e) => {
                            setSelectKeyword(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="tableFixHead" style={{ maxHeight: "550px" }}>
                    <table>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>대분류</th>
                          <th>중분류</th>
                          <th>시험유형</th>
                          <th style={{ width: "500px" }}>문항</th>
                          <th>작업</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(comboList?.data) &&
                          comboList?.data?.map((combo, key) => (
                            <tr key={key}>
                              <td>{combo?.combosn}</td>
                              <td>{`COMBO${combo?.combo}`}</td>
                              <td>
                                {combo?.combo === 1
                                  ? examTypeOptionIfCombo1.find(
                                      (ele) => ele.value === combo.catagory
                                    )?.label
                                  : combo?.combo === 2
                                  ? examTypeOptionIfCombo2.find(
                                      (ele) => ele.value === combo.catagory
                                    )?.label
                                  : combo?.combo === 3
                                  ? examTypeOptionIfCombo3.find(
                                      (ele) => ele.value === combo.catagory
                                    )?.label
                                  : combo?.combo === 4
                                  ? examTypeOptionIfCombo4.find(
                                      (ele) => ele.value === combo.catagory
                                    )?.label
                                  : combo?.combo === 5 &&
                                    examTypeOptionIfCombo5.find(
                                      (ele) => ele.value === combo.catagory
                                    )?.label}
                              </td>
                              <td>
                                {/* todo ::: 시험유형 */}
                                {Object.keys(EXAMTYPE).find(
                                  (key) => EXAMTYPE[key] === combo?.room_type
                                )}
                              </td>
                              <td className="shortening">
                                {/* todo :: 20글자 이상은 ... 으로 표시 */}
                                <p>{combo?.text1}</p>
                                <p>{combo?.text2}</p>
                                <p>{combo?.text3}</p>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="insert-modalbtn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setComboSn(combo?.combosn);
                                    setIsQuestionModifyModalOpen(true);
                                  }}
                                ></button>
                                <button
                                  className="trashbtn"
                                  onClick={() => {
                                    if (
                                      window.confirm("정말 삭제하시겠습니까?")
                                    ) {
                                      var req = { combosn: combo?.combosn };
                                      mutation.mutate(req);
                                    } else {
                                      //   alert("취소합니다.");
                                    }
                                  }}
                                ></button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminQuestionAddModal />
        <AdminQuestionModifyModal questionSn={modifyingSn} />
      </div>
    </>
  );
};

export default AdminQuestion;
